import { render } from "./UpgradeScreen.vue?vue&type=template&id=11d21d3e&scoped=true"
import script from "./UpgradeScreen.vue?vue&type=script&lang=js"
export * from "./UpgradeScreen.vue?vue&type=script&lang=js"

import "./installer-page.scss?vue&type=style&index=0&id=11d21d3e&lang=scss&scoped=true"
import "./UpgradeScreen.vue?vue&type=style&index=1&id=11d21d3e&scoped=true&lang=scss"

import exportComponent from "/var/www/html/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11d21d3e"]])

export default __exports__